import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const resultsDefaultLayout: LayoutRuntime = {
  feature: "results",
  layout: "default",
  rootClass: "gwd-livescore-layout--results",
};
